'use strict';exports.__esModule = true;exports.clearFavorites = exports.addSavedFavoritesToStore = exports.saveFavoritesData = exports.setFavoritesListState = exports.loadFavorites = exports.toggleFavorite = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');

var _pick = require('lodash/pick');var _pick2 = _interopRequireDefault(_pick);
var _union = require('lodash/union');var _union2 = _interopRequireDefault(_union);
var _difference = require('lodash/difference');var _difference2 = _interopRequireDefault(_difference);
var _constants = require('../../constants');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);
var _mergeEntityProperties = require('../../helpers/mergeEntityProperties');
var _services = require('../../services');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;
var necessaryPropertyKeys = ['additional_info', 'address', 'id', 'is_active', 'price', 'property_type', 'thumbnail', 'has_photos', 'images', 'created_at', 'search_option', 'entityType', 'status', 'exact_property_price', 'min_property_price'];
var favoriteUrl = '/users/properties/favourites';

var toggleFavorite = (0, _reduxAct.createAction)('/TOGGLE_IS_FAVORITE');
var setFavoritesListState = (0, _reduxAct.createAction)('/SET_FAVORITES_LIST_STATE');
var saveFavoritesData = (0, _reduxAct.createAction)('/SAVE_FAVORITES_DATA');
var addSavedFavoritesToStore = (0, _reduxAct.createAction)('/ADD_SAVED_FAVORITES_TO_STORE');
var authorisedToggleSuccess = (0, _reduxAct.createAction)('/AUTHORISED_TOGGLE_SUCCESS');
var authorisedToggleFail = (0, _reduxAct.createAction)('/AUTHORISED_TOGGLE_FAIL');
var addFavoritesArraySuccess = (0, _reduxAct.createAction)('/ADD_FAVORITES_ARRAY_SUCCESS');
var addFavoritesArrayFail = (0, _reduxAct.createAction)('/ADD_FAVORITES_ARRAY_FAIL');
var clearFavorites = (0, _reduxAct.createAction)('/CLEAR_FAVORITES');
var loadFavorites = (0, _reduxAct.createAction)('/LOAD_FAVORITES');
var loadFavoritesSuccess = (0, _reduxAct.createAction)('/LOAD_FAVORITES_SUCCESS');
var loadFavoritesFail = (0, _reduxAct.createAction)('/LOAD_FAVORITES_FAIL');

var shouldLoadPropertiesData = function shouldLoadPropertiesData(idsArray, dataArray) {
  var result = false;
  var dataIds = dataArray.map(function (item) {return item.id;});
  idsArray.forEach(function (item) {
    if (dataIds.indexOf(item) === -1) {
      result = true;
    }
  });
  return result;
};

var syncFavorites = function syncFavorites(fromUser, localSaved) {
  var favoriteIDs = (0, _union2.default)(fromUser, localSaved);
  var newFavorites = (0, _difference2.default)(favoriteIDs, fromUser);

  return {
    favoriteIDs: favoriteIDs,
    newFavorites: newFavorites };

};

var deleteSavedFavorites = function deleteSavedFavorites() {return _constants.storage.value.setItem('favoritesData', '');};

var initialState = {
  favoritesListIsActive: false,
  favoriteIDs: [],
  favoritesData: [],
  loading: false,
  loaded: false };


var handleLoadFavoritesData = function handleLoadFavoritesData(token) {return _axios2.default.get(favoriteUrl + '?full=true', {
    headers: { access_token: token } }).

  then(loadFavoritesSuccess, loadFavoritesFail);};

var loadFavoritesHandler = function loadFavoritesHandler(state, token) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true }),
  promise(handleLoadFavoritesData, token));};

var handleAuthorisedToggle = function handleAuthorisedToggle(_ref) {var token = _ref.token,id = _ref.id,isFavorite = _ref.isFavorite,isProject = _ref.isProject;
  var requestType = isFavorite ? 'delete' : 'post';

  return (0, _axios2.default)({
    method: requestType,
    url: favoriteUrl + '/' + id,
    params: { isProject: isProject },
    headers: {
      access_token: token } }).


  then(function (data) {return authorisedToggleSuccess({ action: data, token: token });}, authorisedToggleFail);
};

var handleAddFavoritesArray = function handleAddFavoritesArray(_ref2) {var token = _ref2.token,ids = _ref2.ids;return (
    _axios2.default.post(favoriteUrl, { ids: ids }, { headers: { access_token: token } }).
    then(function (data) {return addFavoritesArraySuccess({ data: data, token: token });}, addFavoritesArrayFail));};

var handleToggleFavorite = function handleToggleFavorite(state, _ref3) {var property = _ref3.property,token = _ref3.token,isProject = _ref3.isProject;
  var setPropertyType = (0, _mergeEntityProperties.setEntityType)(isProject ? _constants.ENTITY_TYPES.PROJECT : _constants.ENTITY_TYPES.PROPERTY);

  var propertyShortData = property ? (0, _pick2.default)(setPropertyType(property), necessaryPropertyKeys) : {};var
  propertyId = propertyShortData.id;
  var favoriteIDs = [].concat(state.favoriteIDs);

  var favoritesData = [].concat(state.favoritesData);
  var startIdxId = state.favoriteIDs.indexOf(propertyId);

  var isFavorite = startIdxId !== -1;

  if (!isFavorite) {
    favoriteIDs.push(propertyId);
    favoritesData.push(Object.assign({}, propertyShortData));
    _services.AnalyticsEventService.createPropertyEvent({ propertyId: propertyId, action: _constants.analyticsEventAction.FAVOURITES });
  } else {
    var startIdxData = startIdxId;
    state.favoritesData.forEach(function (item, idx) {
      if (item.id === propertyId) {
        startIdxData = idx;
      }
    });

    favoriteIDs.splice(startIdxId, 1);
    favoritesData.splice(startIdxData, 1);
  }

  return token ?
  (0, _reduxLoop.loop)(Object.assign({},
  state, {
    favoriteIDs: favoriteIDs,
    favoritesData: favoritesData,
    loading: true }),
  promise(handleAuthorisedToggle, { token: token, id: propertyId, isFavorite: isFavorite, isProject: isProject })) : Object.assign({},

  state, {
    favoriteIDs: favoriteIDs,
    favoritesData: favoritesData });

};

var handleAddSavedFavoritesToStore = function handleAddSavedFavoritesToStore(state, _ref4) {var data = _ref4.data,token = _ref4.token;
  var localSavedFavoritesData = [];
  var localSavedFavoriteIDs = [];
  var savedData = _constants.storage.value.getItem('favoritesData');

  if (savedData) {
    localSavedFavoritesData = JSON.parse(savedData);
    localSavedFavoriteIDs = localSavedFavoritesData.map(function (property) {return property.id;});
    if (token) {
      deleteSavedFavorites();
    }
  } else {
    localSavedFavoriteIDs = [].concat(state.favoriteIDs);
  }var _syncFavorites =

  syncFavorites(data, localSavedFavoriteIDs),favoriteIDs = _syncFavorites.favoriteIDs,newFavorites = _syncFavorites.newFavorites;

  var shouldLoadNewData = token ?
  shouldLoadPropertiesData(favoriteIDs, state.favoritesData) ||
  shouldLoadPropertiesData(favoriteIDs, localSavedFavoritesData) ||
  !favoriteIDs.length && !state.favoritesData.length && !localSavedFavoritesData.length :

  false;

  var result = Object.assign({},
  state, {
    favoritesData: localSavedFavoritesData,
    favoriteIDs: favoriteIDs });


  if (token && newFavorites.length) {
    result = (0, _reduxLoop.loop)(Object.assign({},
    state, {
      favoritesData: localSavedFavoritesData,
      favoriteIDs: favoriteIDs,
      loading: true }),
    promise(handleAddFavoritesArray, { token: token, ids: newFavorites }));
  } else if (token && shouldLoadNewData) {
    result = (0, _reduxLoop.loop)(Object.assign({},
    state, {
      favoriteIDs: favoriteIDs,
      loading: true }),
    promise(handleLoadFavoritesData, token));
  }

  return result;
};

var handleSetFavoritesListState = function handleSetFavoritesListState(state, status) {return Object.assign({},
  state, {
    favoritesListIsActive: status });};


var handleSaveFavoritesData = function handleSaveFavoritesData(state) {
  var data = state.favoritesData.length ? JSON.stringify(state.favoritesData) : [];
  _constants.storage.value.setItem('favoritesData', data);

  return Object.assign({},
  state);

};

var handleClearFavorites = function handleClearFavorites(state) {return Object.assign({},
  state, {
    favoriteIDs: [],
    favoritesData: [] });};


var handleLoadFavoritesDataSuccess = function handleLoadFavoritesDataSuccess(state, action) {
  var favoriteIDs = action.data.propertyFavourites.map(function (item) {return item.id;});
  var favoriteProjectIDs = action.data.projectFavourites.map(function (item) {return item.id;});

  return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    favoritesData: (0, _mergeEntityProperties.mergeEntityProperties)(action.data.propertyFavourites || [], action.data.projectFavourites || []),
    favoriteIDs: [].concat(favoriteIDs, favoriteProjectIDs) });

};

var handleLoadFavoritesDataFail = function handleLoadFavoritesDataFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while loading favourite properties');
  return Object.assign({},
  state, {
    favoritesData: [],
    loading: false,
    loaded: false,
    error: error });

};

var handleAuthorisedToggleSuccess = function handleAuthorisedToggleSuccess(state, _ref5) {var action = _ref5.action,token = _ref5.token;return (
    shouldLoadPropertiesData(action.data, state.favoritesData) ?
    (0, _reduxLoop.loop)(Object.assign({},
    state, {
      loading: true,
      loaded: false }),
    promise(handleLoadFavoritesData, token)) : Object.assign({},

    state, {
      favoriteIDs: action.data,
      loading: false,
      loaded: true }));};



var handleAuthorisedToggleFail = function handleAuthorisedToggleFail(state, action) {
  console.error(action);
  return Object.assign({},
  state, {
    loading: false,
    loaded: false });

};

var handleAddFavoritesArraySuccess = function handleAddFavoritesArraySuccess(state, _ref6) {var action = _ref6.data,token = _ref6.token;return (
    shouldLoadPropertiesData(action.data, state.favoritesData) ?
    (0, _reduxLoop.loop)(Object.assign({},
    state, {
      loading: true,
      loaded: false }),
    promise(handleLoadFavoritesData, token)) : Object.assign({},

    state, {
      favoriteIDs: action.data,
      loading: false,
      loaded: true }));};



var handleAddFavoritesArrayFail = function handleAddFavoritesArrayFail(state, action) {
  console.error(action);
  return Object.assign({},
  state, {
    loading: false,
    loaded: false });

};

var favoriteProperties = (0, _reduxAct.createReducer)(function (on) {
  on(toggleFavorite, handleToggleFavorite);
  on(setFavoritesListState, handleSetFavoritesListState);
  on(saveFavoritesData, handleSaveFavoritesData);
  on(addSavedFavoritesToStore, handleAddSavedFavoritesToStore);
  on(clearFavorites, handleClearFavorites);
  on(loadFavorites, loadFavoritesHandler);
  on(loadFavoritesSuccess, handleLoadFavoritesDataSuccess);
  on(loadFavoritesFail, handleLoadFavoritesDataFail);
  on(authorisedToggleSuccess, handleAuthorisedToggleSuccess);
  on(authorisedToggleFail, handleAuthorisedToggleFail);
  on(addFavoritesArraySuccess, handleAddFavoritesArraySuccess);
  on(addFavoritesArrayFail, handleAddFavoritesArrayFail);
}, initialState);exports.


toggleFavorite = toggleFavorite;exports.
loadFavorites = loadFavorites;exports.
setFavoritesListState = setFavoritesListState;exports.
saveFavoritesData = saveFavoritesData;exports.
addSavedFavoritesToStore = addSavedFavoritesToStore;exports.
clearFavorites = clearFavorites;exports.default =


favoriteProperties;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/favoriteProperties.js
// module id = 101
// module chunks = 0